// src/routes/Home.js
import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import Projects from "../components/Projects";
import Skills from "../components/Skills";
import Certificates from "../components/Certificates";
import Footer from "../components/Footer";

const Home = () => (
  <div>
    <Navbar />
    <Hero />
    <Projects limit={3} title="Featured Projects" showAll />
    <Skills />
    <Certificates limit={3} title="Featured Certificates" showAll />
    <Footer />
  </div>
);

export default Home;
